let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k8t1T")).then(() => parcelRequire('frxsR'));